import { DarkModeProvider } from "./context/DarkModeContext";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import GlobalStyles from "./styles/GlobalStyles";

import Home from "./pages/Home";
import CountryInfo from "./pages/CountryInfo";
import Error from "./pages/Error";

import Header from "./components/Header";

function App() {
  return (
    <DarkModeProvider>
      <GlobalStyles />
      <Header />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/country-info/:cca3" element={<CountryInfo />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </DarkModeProvider>
  );
}

export default App;
